import clsx from 'clsx';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox } from '../ui/checkbox';
import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '../ui/form';

interface IShadCnFormCheckboxProps {
  name: string;
  label?: string;
  description?: string;
  className?: string;
}

const ShadCnFormCheckbox: React.FunctionComponent<IShadCnFormCheckboxProps> = ({
  name,
  label,
  description,
  className,
}) => {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={clsx('flex items-start space-x-3 space-y-0', className)}>
          <FormControl>
            <Checkbox checked={field.value} onCheckedChange={field.onChange} />
          </FormControl>
          <div className='space-y-1 leading-none'>
            {!!label && <FormLabel className='cursor-pointer font-normal'>{label}</FormLabel>}
            {!!description && <FormDescription>{description}</FormDescription>}
          </div>
        </FormItem>
      )}
    />
  );
};

export default ShadCnFormCheckbox;
